import React from "react";
import "./Table.scss";

function Table({columns, data}) {
    return (
        <div className="table-container">
            <table className="styled-table">
                <thead>
                <tr>
                    {columns.map((col, index) => (
                        <th
                            key={index}
                            style={{
                                padding: "8px",
                                textAlign: col.accessor === "actions" ? "right" : "left"
                            }}
                            className={col.accessor ? `header-${col.accessor}` : ''}
                        >
                            {col.header}
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {columns.map((col, colIndex) => (
                            <td key={colIndex} style={{padding: "8px"}} className={col.accessor ? `data-${col.accessor}` : ''}>
                                {col.render ? col.render(row) : row[col.accessor]}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}

export {Table};
